<template>
  <div id="app"  class="fullscreen bg">
    <!-- <HelloWorld /> -->
    <router-view></router-view>
  </div>
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'App',
  components: {
    HelloWorld
  }
}
</script>

<style lang="scss">
.fullscreen {
  width: 100vw;     /* 视口宽度 */
  height: 100vh;    /* 视口高度 */
  overflow: hidden; /* 防止内容溢出 */
  position: fixed;  /* 固定定位 */
  top: 0;
  left: 0;
  box-sizing: border-box; /* 边框盒模型 */
  margin: 0;
  padding: 0;
}
.bg {
  width: 100%;
  height: 100%;
  background-image: url("./assets/pageBg.png");
  background-size: cover;
  background-position: center center;
}
</style>
